import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [ "content", "icon" ]

    toggle() {
        this.contentTarget.classList.toggle("hidden")
        const isHidden = this.contentTarget.classList.contains("hidden")
        this.iconTarget.textContent = isHidden ? "expand_more" : "expand_less"
    }
}